import { render, staticRenderFns } from "./ConnectionArrow.vue?vue&type=template&id=38798149&scoped=true&"
import script from "./ConnectionArrow.vue?vue&type=script&lang=ts&"
export * from "./ConnectionArrow.vue?vue&type=script&lang=ts&"
import style0 from "./ConnectionArrow.vue?vue&type=style&index=0&id=38798149&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38798149",
  null
  
)

export default component.exports